import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/** views/expense/expenseTypes/from has a single field. `created_at` is not in it. */
export default defineInlineEdit({
  api: "expenseTypes",
  permission: "spending_type_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
